var _circle, _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50081,
    cy: 4.99984,
    r: 3.33333,
    fill: "white",
    fillOpacity: 0.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.50081,
    cy: 14.1673,
    rx: 5.83333,
    ry: 3.33333,
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4996 14.1669C17.4996 15.5476 15.8033 16.6669 13.7322 16.6669C14.3424 16 14.762 15.1628 14.762 14.1681C14.762 13.1722 14.3414 12.3343 13.7301 11.667C15.8012 11.667 17.4996 12.7862 17.4996 14.1669Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 5.00049C14.9996 6.3812 13.8803 7.50049 12.4996 7.50049C12.1985 7.50049 11.9099 7.44727 11.6426 7.34972C12.0368 6.65631 12.262 5.85423 12.262 4.99956C12.262 4.14552 12.0372 3.34399 11.6435 2.65093C11.9105 2.55359 12.1989 2.50049 12.4996 2.50049C13.8803 2.50049 14.9996 3.61978 14.9996 5.00049Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/Partners.94ae3e8c62b83677e423a98a336d72df.svg";
export { ForwardRef as ReactComponent };